import React, { useRef } from "react";
import { bestSellers } from "../mock";
import ProductCard from "./ProductCard";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function BestSellers() {
  const scroller = useRef(null);
  const ref = useReveal();
  const scroll = (dir) => scroller.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  return (
    <section className="bg-white py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">Best Sellers</h2>
            <p className="mt-2 text-sm text-navy/60">Our most popular gear, loved by Aussie lifters.</p>
          </div>
          <div className="hidden gap-2 md:flex">
            <button onClick={() => scroll(-1)} className="flex h-10 w-10 items-center justify-center rounded-full border border-navy/20 text-navy transition-colors hover:bg-navy hover:text-white" aria-label="Previous"><ChevronLeft size={18} /></button>
            <button onClick={() => scroll(1)} className="flex h-10 w-10 items-center justify-center rounded-full bg-navy text-white transition-colors hover:bg-brand" aria-label="Next"><ChevronRight size={18} /></button>
          </div>
        </div>
        <div ref={scroller} className="no-scrollbar flex snap-x gap-5 overflow-x-auto pb-2">
          {bestSellers.map((p) => (
            <ProductCard key={p.id} p={p} className="w-[240px] shrink-0 snap-start" />
          ))}
        </div>
      </div>
    </section>
  );
}
